enum CurrencyType {
    NGN = "NGN",
    CAD = "CAD",
    USD = "USD"

}

export default {
    CurrencyType
}